<section class="rental-item-container">
  <common-icon-button-secondary
    *ngIf="rentalItem.rentalStage != 'ReturnFulfillment' && rentalItem.rentalStage != 'Completed' && rentalItem.rentalStage != 'Cancelled'"
    (btnClick)="rentalItem.statusData.disableStartReturn || !rentalItem.statusData.showStartReturn ? null : startReturn()"
    iconClass="icon-left"
    buttonText="Start Return"
    [ngbTooltip]="rentalItem.statusData.disableStartReturn ? tooltipContent : ''"
    placement="top"
    tooltipClass="custom-tooltip"
    triggers="click:blur"
  ></common-icon-button-secondary>

  <div class="mt-3">
    <p class="mb-0">For service inquiries:</p>
    <p class="font-weight-light">Call us at <a href="tel:(866) 455-8531">(866) 455-8531</a></p>
  </div>
</section>

<ng-template #tooltipContent>
  <span
    >The minimum rental length is 3 days. If you need to return your machine early,
    <span class="cursor-pointer text-green bold" (click)="contactUs()"> contact us.</span></span
  >
  &nbsp;
</ng-template>
